import apiClient from "@/app/api/client";
import type { LoginRequest, LoginResponse, MeResponse, User } from "../types";

export const authService = {
	async login(data: LoginRequest): Promise<{ user: User; token: string }> {
		const response = await apiClient.post<LoginResponse>("/auth/login", data);
		return response.data.data;
	},

	async logout(): Promise<void> {
		await apiClient.post("/auth/logout");
	},

	async getMe(): Promise<User> {
		const response = await apiClient.get<MeResponse>("/auth/me");
		return response.data.data;
	},
};
